import { render } from "./FormDataTableV2.vue?vue&type=template&id=7b2facb9&scoped=true"
import script from "./FormDataTableV2.vue?vue&type=script&lang=js"
export * from "./FormDataTableV2.vue?vue&type=script&lang=js"

import "./FormDataTableV2.vue?vue&type=style&index=0&id=7b2facb9&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2facb9"]])

export default __exports__